import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { useRouter } from "./store/router";
import { installGlobalErrorHandlers } from "./telemetry/globalErrors";
// 폰트 self-host — 매장 네트워크가 끊겨도 서체 톤 유지 (HERIT: 제목 Cormorant Garamond 300 + Nanum Myeongjo, 본문 Noto Sans KR)
import "@fontsource/cormorant-garamond/300.css";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/nanum-myeongjo/400.css";
import "@fontsource/nanum-myeongjo/700.css";
import "@fontsource/noto-sans-kr/300.css";
import "@fontsource/noto-sans-kr/400.css";
import "@fontsource/noto-sans-kr/500.css";
// JP/SC 로케일 서체 (BOOTH-30) — <html lang> 에 따라 globals.css 의 `html:lang()` 규칙이 스택을 바꾼다.
// fontsource 가 유니코드 서브셋 단위로 쪼개 두므로 실제로는 화면에 쓰인 글리프 청크만 내려받는다.
import "@fontsource/noto-serif-jp/400.css";
import "@fontsource/noto-serif-jp/700.css"; // poster ja/zh 굵은 명조 (BOOTH-85)
import "@fontsource/noto-sans-jp/300.css";
import "@fontsource/noto-sans-jp/400.css";
import "@fontsource/noto-sans-jp/500.css";
import "@fontsource/noto-serif-sc/400.css";
import "@fontsource/noto-serif-sc/700.css"; // poster ja/zh 굵은 명조 (BOOTH-85)
import "@fontsource/noto-sans-sc/300.css";
import "@fontsource/noto-sans-sc/400.css";
import "@fontsource/noto-sans-sc/500.css";
// 자막 스타일 서체 (BOOTH-85) — 손글씨 3종 + Noto 700 (neon·sticker·poster 용)
import "@fontsource/nanum-pen-script/400.css";
import "@fontsource/yomogi/400.css";
import "@fontsource/ma-shan-zheng/400.css";
import "@fontsource/noto-sans-kr/700.css";
import "@fontsource/noto-sans-jp/700.css";
import "@fontsource/noto-sans-sc/700.css";
// 자막 스타일 2차 — brush·gilt·sea·postit (BOOTH-85)
import "@fontsource/east-sea-dokdo/400.css";
import "@fontsource/yuji-syuku/400.css";
import "@fontsource/zhi-mang-xing/400.css";
import "@fontsource/song-myung/400.css";
import "@fontsource/cinzel/400.css";
import "@fontsource/shippori-mincho/400.css";
import "@fontsource/zcool-xiaowei/400.css";
import "@fontsource/gowun-dodum/400.css";
import "@fontsource/zen-maru-gothic/400.css";
import "@fontsource/gamja-flower/400.css";
import "./styles/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing from index.html");

// BOOTH-116 이전 기기 저장 언어 — 부스 설정이 대신한다. 남아 있는 옛 키만 1회 지운다(실패해도 동작엔 영향 없음)
try {
  localStorage.removeItem("booth-web:language");
} catch {
  /* 프라이빗 모드 등 — 무시 */
}

// 첫 페인트부터 기본 언어의 서체·줄바꿈 규칙이 적용되도록 render 전에 <html lang> 을 맞춘다 (App.tsx 의 effect 는 이후 변경을 따라간다)
document.documentElement.lang = useRouter.getState().language;

// 전역 오류·거절 수집 (BOOTH-97) — 렌더 전에 걸어야 부팅 중 터진 예외도 잡힌다
installGlobalErrorHandlers();

// DEV 전용: Playwright 테스트가 React 의 동일한 스토어 인스턴스에 접근할 수 있게 전역 노출.
// dynamic import("/src/store/router.ts") 는 별개의 모듈 인스턴스를 생성해 React 리렌더를 트리거하지 않는다.
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>).__kioskRouter = useRouter;
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
